export const WEAPON = {
  id: 'smg',
  label: 'MPX-9',
  class: 'smg',
  caliber: '9x19',
  /** Gold-coin price in the armory; 0 = free starter/melee, never purchasable. */
  price: 800,
  rpm: 950,
  modes: ['auto', 'semi'],
  burstCount: 2,
  burstRpm: 1100,
  burstDelay: 0.14,
  magSize: 32,
  reserve: 224,
  muzzleVelocity: 400,
  damage: 24,
  penetration: 0.45,
  dropoff: 0.48,
  maxRange: 240,
  dragK: 0.42,
  tracerEvery: 4,
  spreadHip: 2.5,
  spreadAds: 0.4,
  spreadPerShot: 0.26,
  spreadMax: 3.9,
  spreadDecay: 4.4,
  recoil: {
    pitch: 0.0058,
    yaw: 0.0026,
    kickBack: 0.0135,
    kickUp: 0.0052,
    roll: 0.026,
    punch: 0.24,
    freq: 10.5,
    damping: 0.4,
    patternLength: 32,
    patternSeed: 0x9ac31f,
    climbShape: [1.3, 1.18, 1.08, 1.0],
    drift: 0.8,
  },
  adsTime: 0.185,
  adsFov: 0.78,
  viewFov: 0.88,
  reloadTac: 1.85,
  reloadEmpty: 2.5,
  inspectTime: 2.9,
  drawTime: 0.52,
  holsterTime: 0.34,
  /* Solved from the bore axis exactly as the rifle's is (see there): 4.1 deg of
   * convergence, 2.9 deg nose-down, 7.5 deg of outboard roll, and far enough
   * out that the muzzle of a 210 mm barrel is on screen up-left of the optic. */
  hipPos: [0.111, -0.163, -0.288],
  hipRot: [-0.05, 0.072, -0.131],
  adsCant: [0, 0, 0.005],
  /* Same aperture-budget derivation as the rifle (see there): the 27.6 mm tube's
   * outer rim wants to land near 165 px of radius and the 44 mm bore wants the
   * eye far enough back that the objective is not the stop. */
  eyeRelief: 0.104,
  sprintPos: [0.088, -0.24, -0.262],
  sprintRot: [-0.38, 0.58, 0.19],
  lowReadyPos: [0.108, -0.252, -0.276],
  lowReadyRot: [-0.44, 0.125, -0.085],
  swayScale: 0.92,
  bobScale: 0.95,
  magLen: 0.192,
};

export const loadModel = () => import('../models/smg.js').then((m) => m.buildSmg);
